class Top {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    let mvSwiper = new Swiper('.mvSwiper', {  
      loop: true,
      speed: 2000,
      effect: "fade", 
      fadeEffect: {
        crossFade: true,
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
    });

    let bannerSwiper = new Swiper('.bannerSwiper', {
      loop: true,
      speed: 1000,
      centeredSlides: true,
      slidesPerView: 1.4,
      spaceBetween: 14,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
      },
      navigation: {
        nextEl: ".js-banner-next",
        prevEl: ".js-banner-prev",
      },
      pagination: {
        el: '.bannerSwiper .swiper-pagination',
        clickable: true,
      },
    });

    let productSwiper = new Swiper('.productSwiper', {
      loop: false,
      speed: 2000,
      slidesPerView: 2,
      spaceBetween: 8,    
      navigation: {
        nextEl: ".js-product-next",
        prevEl: ".js-product-prev",
      },
      breakpoints: {
        768: {
          slidesPerView: 4,
          spaceBetween: 16,
        },
      },    
      on: {
        init: function (swiper) {
          updateProductPager(swiper);
          window.addEventListener("resize", () => updateProductPager(swiper));
        },
        slideChange: function (swiper) {
          updateProductPager(swiper);
        },
      },
    });

    function updateProductPager(swiper) {
      const pager = document.querySelector(".js-product-pagination");
      const bar = pager?.querySelector("span");
      if (!pager || !bar) return;
    
      const pagerWidth = pager.clientWidth;
    
      const totalSlides = swiper.slides.length;
      const perView = swiper.params.slidesPerView;
    
      const totalSteps = totalSlides - perView + 1;
      const currentStep = swiper.activeIndex;
    
      const barWidth = pagerWidth / totalSteps;
      const translateX = currentStep * barWidth;
    
      bar.style.width = `${barWidth}px`;
      bar.style.transform = `translateX(${translateX}px)`;
    }
  }
}
